import React, { useState } from 'react';

import { AthleteRetrieve } from 'types';

import AthleteCreditsFilter from './components/AthleteCreditsFilter';
import AthleteCreditsTableContainer from './components/AthleteCreditsTableContainer';

interface ICreditsProps {
  athlete: AthleteRetrieve;
  permission?: boolean;
}

const Credits = ({ athlete, permission }: ICreditsProps): JSX.Element => {
  const [validityDate, setValidityDate] = useState<Date>(new Date());
  return (
    <>
      <AthleteCreditsFilter validityDate={validityDate} setValidityDate={setValidityDate} />
      <AthleteCreditsTableContainer
        athleteId={athlete.athleteId}
        validityDate={validityDate}
        permission={permission}
      />
    </>
  );
};

export default Credits;
